import { apiSlice } from "@/services/api-slice";
import { clearAuth } from "./authSlice";
import { AuthRequest, AuthResponse } from "./auth.interface";
import { APIResponse } from "@/types/custom-http";

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    // iniciar sesión
    login: builder.mutation<APIResponse<AuthResponse>, AuthRequest>({
      query: (credentials) => ({
        url: '/session/access/sign-in',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth'],
    }),


    // cerrar sesión
    logout: builder.mutation<void, void>({
      query: () => ({
        url: '/session/access/sign-out',
        method: 'GET',
      }),
      invalidatesTags: ['Auth'],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(clearAuth());
          sessionStorage.removeItem('refresh_token');
        } catch (error: unknown) {
          // const messageToUser = handleErrorApi(error);
          // console.error(messageToUser + ' - Error al cerrar sesión:' + error);
          console.error(' - Error al cerrar sesión:' + error);
        }
      },
    }),

  }),

});


// Exportar hooks generados
export const {
  useLoginMutation,
  useLogoutMutation,
} = authApi;